import { DialogWindow } from 'src/components/widgets/dialog';
import styled from 'styled-components';

/** Shared window dimensions for every dialog in the sales-channel switch wizard. */
export const SwitchDialogWindow = styled(DialogWindow)`
    flex-basis: 820px;
    height: calc(90vh - 20px);
    padding-left: 24px !important;
    padding-right: 24px !important;
    display: flex;
    flex-direction: column;
`;

/**
 * Half-height variant for the blocking-product dialogs: their content is short, so a fixed shorter window keeps them
 * from being a tall, mostly-empty box.
 */
export const SwitchBlockedDialogWindow = styled(SwitchDialogWindow)`
    height: calc(45vh - 10px);
`;

/**
 * Auto-height variant for the short dead-end dialogs that show a single warning banner (manual migration, legacy plan).
 * The base window pads 40px top / 20px bottom; here the bottom matches the top so the short content sits evenly.
 */
export const SwitchAutoHeightDialogWindow = styled(SwitchDialogWindow)`
    height: auto;
    max-height: calc(90vh - 20px);
    padding-bottom: 40px;
`;
